import request from '@/utils/request';

const projectName = '/api/blade-platform';

const deviceMan = {
  state: {
    roleList: null,
  },
  mutations: {
    SET_Contacts_RoleList(state, result) {
      const st = state;
      st.roleList = result;
    },
  },
  actions: {
    /**
     * 登录设备列表/查询
     * @param {*} param0 context
     */
    loginEquipmentList({ commit }, data) {
      return request({
        url: `${projectName}/loginequipment/List`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    /**
     * 紧急联系人列表/查询
     * @param {*} param0 context
     */
    getEmergencyList({ commit }, data) {
      return request({
        url: `${projectName}/emergency/List`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    // 获取紧急联系人管理检索条件---获取角色列表
    platformalumniuserRoleList({ commit }, data) {
      return request({
        url: `${projectName}/platformalumniuser/roleList`,
        method: 'post',
        data,
      }).then((res) => {
        commit('SET_Contacts_RoleList', res.data.result)
        return Promise.resolve(res);
      });
    },
    // 获取紧急联系人 详情
    getEmergencyDetails({ commit }, data) {
      return request({
        url: `${projectName}/emergency/details`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    // 条件查询版本管理列表 app版本管理
    getAppVersionList({ commit }, data) {
      return request({
        url: `${projectName}/platformAppVersionManage/getAppVersionList`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    // 新增/修改版本记录
    saveAppVersion({ commit }, data) {
      return request({
        url: `${projectName}/platformAppVersionManage/saveOrUpdateAppVersion`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    // 批量删除版本记录
    deleteVersionByIds({ commit }, data) {
      return request({
        url: `${projectName}/platformAppVersionManage/deleteVersionByIds`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
  },
};

export default deviceMan;
